import { Buttons, Image, PaginationFraction, Scroller, Slider, Overlay as SliderOverlay } from '@cian/slider';

import { type ReactNode, useCallback } from 'react';

import { useCardContext } from '@/microfrontends/listing/shared/context/CardContext';
import { cardOfferDataSelector } from '@/microfrontends/listing/shared/context/selectors';

import { useCAForCard } from '../../../hooks/card/useCAForCard';
import { GalleryPaginationFractionWrapper } from '../components/GalleryPaginationFractionWrapper';
import { PessimizationOverlay } from '../components/PessimizationOverlay';
import { Stub } from '../components/Stub';

export function SliderContainer(): ReactNode {
  const cardData = useCardContext();
  const caForCard = useCAForCard();

  const {
    media: { photos, moderationFirstPhotoOverlay },
  } = cardOfferDataSelector(cardData);

  const onSlideChange = useCallback(() => {
    caForCard({ action: 'slide_photo', category: 'Listing', label: 'from_newlist' });
  }, [caForCard]);

  if (photos.length === 0) {
    return <Stub pessimization={moderationFirstPhotoOverlay} />;
  }

  return (
    <Slider loop onSlideChange={onSlideChange}>
      <Scroller>
        {photos.map((photo, index) => {
          const key = `slide_${photo.id}`;
          const slide: React.ReactNode = (
            <span data-testid={`card-gallery.slide-${index + 1}`}>
              <Image key={key} priority={cardData.index === 0 && index === 0} src={photo.src} />
            </span>
          );

          if (index === 0 && moderationFirstPhotoOverlay) {
            return (
              <PessimizationOverlay key={key} pessimization={moderationFirstPhotoOverlay}>
                {slide}
              </PessimizationOverlay>
            );
          }

          return slide;
        })}
      </Scroller>

      <SliderOverlay>
        {photos.length > 1 && <Buttons size="S" />}

        <GalleryPaginationFractionWrapper>
          <PaginationFraction />
        </GalleryPaginationFractionWrapper>
      </SliderOverlay>
    </Slider>
  );
}
